const STORAGE_KEY = 'hotel-voice:location';

export interface GuestLocation {
  hotelId: string;
  roomId: string;
}

/**
 * The guest arrives at `?hotelId=hotel001&roomId=205` (from the in-room QR
 * code). We remember it so a reload or a returning tab still works, but the
 * values are only ever a *hint*: the server validates both and decides whether
 * this guest may call from that room.
 */
export function readGuestLocation(): GuestLocation | null {
  const params = new URLSearchParams(window.location.search);
  const hotelId = params.get('hotelId')?.trim();
  const roomId = params.get('roomId')?.trim();

  if (hotelId && roomId) {
    const location = { hotelId, roomId };
    rememberGuestLocation(location);
    return location;
  }

  return recallGuestLocation();
}

function rememberGuestLocation(location: GuestLocation): void {
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(location));
  } catch {
    // Private browsing can refuse storage; the query string still works.
  }
}

function recallGuestLocation(): GuestLocation | null {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<GuestLocation>;
    if (typeof parsed.hotelId === 'string' && typeof parsed.roomId === 'string') {
      return { hotelId: parsed.hotelId, roomId: parsed.roomId };
    }
  } catch {
    // Corrupt value — treat as absent.
  }
  return null;
}
